import { Card, CardContent, Checkbox, FormControlLabel, Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import AddPlusIcon from "../../../assets/svg/AddPlusIcon.svg";
import SubtractMinusIcon from "../../../assets/svg/SubtractMinusIcon.svg";
import { CREATE_TIME_BASED_CONFIGURATIONS, DELIVERY_FEE_TEXT_CONSTANT } from "../../Utils/DeliveryFeeConstants";
import { SlotCapacityViewUtilisationConfigurationInterface, slotProximityFeeConfigDTOListInterface } from "../../Utils/DeliveryFeeInterface";
import { isEmptyOrNull, isUndefined } from "../../../../utils/DataUtils";

interface AddConfigurationsCommonTextUIViewInterface {
  classes: any;
}

export const AddConfigurationsCommonTextUIView = (props: AddConfigurationsCommonTextUIViewInterface) => {
  const { classes } = props;
  return (
    <>
      <AddCircleOutlineIcon className={classes.addConfigIconStyle} />
      <Typography className={classes.addConfigTextStyle}>{`${CREATE_TIME_BASED_CONFIGURATIONS}`}</Typography>
    </>
  );
};

export const isParentConfigurationPresent = (multiShipmentLevel: any, orderThreshold: any, belowThreshold: any, aboveThreshold: any) => {
  return multiShipmentLevel === false &&
    !isEmptyOrNull(orderThreshold) &&
    !isEmptyOrNull(belowThreshold) &&
    !isEmptyOrNull(aboveThreshold);
}

interface AddConfigurationsTextInterface {
  classes: any;
  name: any;
  multiShipmentLevel: any;
  orderThreshold: any;
  belowThreshold: any;
  aboveThreshold: any;
  _handle_open_configuration_dialog: any;
}

export const AddConfigurationsText = (props: AddConfigurationsTextInterface) => {
  const { classes, name, multiShipmentLevel, orderThreshold, belowThreshold, aboveThreshold, _handle_open_configuration_dialog } = props;

  const isPresent = isParentConfigurationPresent(multiShipmentLevel, orderThreshold, belowThreshold, aboveThreshold);
  const className = isPresent ? classes.addConfigIconDivStyle : classes.addConfigIconDivStyleDisabled;

  return (
    <Grid container className={classes.addConfigIconMainDivStyle}>
      <Grid item xs={12} className={className} tabIndex={isPresent ? 0 : -1} onClick={isPresent ? () => _handle_open_configuration_dialog(name, multiShipmentLevel) : undefined}>
        <AddConfigurationsCommonTextUIView classes={classes} />
      </Grid>
    </Grid>
  );
};

interface AddThresoldRangeTextInterface {
  classes: any;
  name: any;
  multiShipmentLevel: any;
  orderThreshold: any;
  belowThreshold: any;
  aboveThreshold: any;
  _handle_click_add_threshold_range: any;
}

export const AddThresoldRangeText = (props: AddThresoldRangeTextInterface) => {
  const { classes, name, multiShipmentLevel, orderThreshold, belowThreshold, aboveThreshold, _handle_click_add_threshold_range } = props;

  const isPresent = isParentConfigurationPresent(multiShipmentLevel, orderThreshold, belowThreshold, aboveThreshold);
  const buttonTitle = "Add threshold range";
  const className = isPresent ? classes.addInnerConfigIconDivStyle : classes.addInnerConfigIconDivStyleDisabled;

  return (
    <Grid container className={classes.addConfigIconMainDivStyle}>
      <Grid item xs={12} className={className} onClick={isPresent ? () => _handle_click_add_threshold_range(name, multiShipmentLevel) : undefined}>
        {isPresent ? (
          <>
            <AddCircleOutlineIcon className={classes.addConfigIconStyle} />
            <Typography className={classes.addConfigTextStyle}>{buttonTitle}</Typography>
          </>
        ) : (
          <Tooltip title="Add threshold range">
            <img src={AddPlusIcon} alt="AddPlusIcon" className={classes.addThresholdRangeConfigIconStyle} />
          </Tooltip>
        )}
      </Grid>
    </Grid>
  )
};

interface AddSubtractThresholdRangeObjectButtonsInterface {
  classes: any;
  name: any;
  multiShipmentLevel: any;
  rangeObject: any;
  _handle_click_delete_threshold_range: any;
  _handle_click_add_threshold_range: any;
}

export const AddSubtractThresholdRangeObjectButtons = (props: AddSubtractThresholdRangeObjectButtonsInterface) => {
  const { classes, name, multiShipmentLevel, rangeObject, _handle_click_delete_threshold_range, _handle_click_add_threshold_range } = props;
  return (
    <>
      <IconButton
        aria-label="Subtract Minus Icon"
        className={classes.actionIconStyle}
        onClick={() => _handle_click_delete_threshold_range(name, multiShipmentLevel)}
      >
        <img src={SubtractMinusIcon} alt="SubtractMinusIcon" />
      </IconButton>

      {!isEmptyOrNull(rangeObject?.newOrderThreshold) && Number(rangeObject.newOrderThreshold) > Number(rangeObject.previousOrderThreshold) && (
        <IconButton
          aria-label="Add Plus Icon"
          className={classes.actionIconStyle}
          onClick={() => _handle_click_add_threshold_range(name, multiShipmentLevel)}
        >
          <img src={AddPlusIcon} alt="AddPlusIcon" className={classes.actionIconStyle} />
        </IconButton>
      )}
    </>
  );
};

interface AddCapacityUtilisationRangeTextInterface {
  classes: any;
  _handle_click_add_capacity_range: any;
  capacityHigh: any;
  capacityLow: any;
  deliveryFee: any;
}

export const AddCapacityUtilisationRangeText = (props: AddCapacityUtilisationRangeTextInterface) => {
  const { classes, _handle_click_add_capacity_range, capacityHigh, capacityLow, deliveryFee } = props;

  const _check_if_parent_configuratopn_present = () => {
    return !isEmptyOrNull(capacityLow) && !isEmptyOrNull(capacityHigh) && Number(capacityHigh) < 100 && !isEmptyOrNull(deliveryFee);
  };

  const isPresent = _check_if_parent_configuratopn_present();
  const className = isPresent ? classes.addConfigIconDivStyle : classes.addConfigIconDivStyleDisabled;

  return (
    <Grid container className={classes.addConfigIconMainDivStyle}>
      <Grid item xs={12} className={className} onClick={isPresent ? (e) => _handle_click_add_capacity_range() : undefined}>
        <AddCircleOutlineIcon className={classes.addConfigIconStyle} />
        <Typography className={classes.addConfigTextStyle}>Add Range</Typography>
      </Grid>
    </Grid>
  );
};

interface AddSubtractCapacityRangeObjectButtonsInterface {
  classes: any;
  _handle_click_add_capacity_range: any;
  capacityHigh: any;
  capacityLow: any;
  deliveryFee: any;
  state_index: any;
  _handle_click_remove_capacity_range: any;
}

export const AddSubtractCapacityRangeObjectButtons = (props: AddSubtractCapacityRangeObjectButtonsInterface) => {
  const { classes, _handle_click_add_capacity_range, capacityHigh, capacityLow, deliveryFee, _handle_click_remove_capacity_range, state_index } = props;

  const isParentConfigurationPresent = () => {
    return !isEmptyOrNull(capacityLow) && !isEmptyOrNull(capacityHigh) && Number(capacityLow) < 100 && !isEmptyOrNull(deliveryFee);
  };
  const isPresent = isParentConfigurationPresent();

  return (
    <>
      <IconButton
        aria-label="Subtract Minus Icon"
        className={classes.actionIconStyle}
        onClick={() => _handle_click_remove_capacity_range(state_index)}
      >
        <img src={SubtractMinusIcon} alt="SubtractMinusIcon" />
      </IconButton>

      {isPresent && (
        <IconButton
          aria-label="Subtract Minus Icon"
          className={classes.actionIconStyle}
          onClick={_handle_click_add_capacity_range}
        >
          <img src={AddPlusIcon} alt="AddPlusIcon" />
        </IconButton>
      )}
    </>
  );
};

interface ChangeConfigOtionProps {
  is_edit_mode: any;
  classes: any;
  use_existing_config_change_handler: any;
  use_existing_checked: any;
  change_existing_checked: any;
  use_change_existing_config_change_handler: any;
}

export const ChangeConfigOtion = (props: ChangeConfigOtionProps) => {
  const { classes, is_edit_mode, use_existing_config_change_handler, use_existing_checked, change_existing_checked, use_change_existing_config_change_handler } = props;
  return (
    <Grid item xs={12} className={classes.dFlexEnd}>
      {is_edit_mode ? (
        <FormControlLabel
          control={<Checkbox className={classes.switchStyle} checked={change_existing_checked} onChange={use_change_existing_config_change_handler} />}
          label={<Typography className={classes.dlvFeeCalculationTextStyle}>Change existing configuration</Typography>}
        />
      ) : (
        <FormControlLabel
          control={<Checkbox className={classes.switchStyle} checked={use_existing_checked} onChange={use_existing_config_change_handler} />}
          label={<Typography className={classes.dlvFeeCalculationTextStyle}>Use existing configuration</Typography>}
        />
      )}
    </Grid>
  );
};

interface ThresholdRangeTooltipViewUtilInterface {
  classes: any;
  orderThreshold: string | number;
  aboveThreshold: string | number;
  belowThreshold: string | number;
  deliveryFeeRangeConfigDTOList: any;
}
export const ThresholdRangeTooltipViewUtil = (props: ThresholdRangeTooltipViewUtilInterface) => {
  const { classes, orderThreshold, aboveThreshold, belowThreshold, deliveryFeeRangeConfigDTOList } = props;
  return (
    <Card>
      <CardContent className={classes.thresholdRangeTooltipCardContent}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>Greater than or Equals to (Threshold Value)</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>Less than (Threshold Value)</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>Delivery Fee</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deliveryFeeRangeConfigDTOList !== undefined &&
              Array.isArray(deliveryFeeRangeConfigDTOList) &&
              deliveryFeeRangeConfigDTOList.length > 0 &&
              deliveryFeeRangeConfigDTOList.map((fee: any, fee_index: any) => (
                <TableRow key={`${fee_index}-deliveryFeeRangeConfigDTOList-delivery-Fee-${fee?.orderThreshold ?? ""}`}>
                  <TableCell className={classes.thresholdRangeTooltipTableCell}>{fee_index === 0 ? "" : deliveryFeeRangeConfigDTOList[fee_index - 1]?.orderThreshold ?? ""}</TableCell>
                  <TableCell className={classes.thresholdRangeTooltipTableCell}>{fee?.orderThreshold ?? ""}</TableCell>
                  <TableCell className={classes.thresholdRangeTooltipTableCell}>{fee?.deliveryFee ?? ""}</TableCell>
                </TableRow>
              ))}
            <TableRow>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${deliveryFeeRangeConfigDTOList[deliveryFeeRangeConfigDTOList?.length - 1]?.orderThreshold}`}</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{orderThreshold}</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${belowThreshold}`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{orderThreshold}</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{""}</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${aboveThreshold}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

interface ServiceFeeTooltipViewUtilInterface {
  classes: any;
  dynamicFeeRange: any;
}
export const ServiceFeeTooltipViewUtil = (props: ServiceFeeTooltipViewUtilInterface) => {
  const { classes, dynamicFeeRange } = props;
  return (
    <Card>
      <CardContent className={classes.thresholdRangeTooltipCardContent}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>Fee Percentage</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>Min Value</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>Max Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dynamicFeeRange !== undefined &&
              Array.isArray(dynamicFeeRange) &&
              dynamicFeeRange.length > 0 &&
              dynamicFeeRange.map((fee: any, fee_index: any) => (
                <TableRow key={`${fee_index}-dynamicFeeRange-service-Fee-${fee?.feePercentage ?? ""}`}>
                  <TableCell className={classes.thresholdRangeTooltipTableCell}>{fee?.feePercentage ?? ""}</TableCell>
                  <TableCell className={classes.thresholdRangeTooltipTableCell}>{fee?.minValue ?? ""}</TableCell>
                  <TableCell className={classes.thresholdRangeTooltipTableCell}>{fee?.maxValue ?? ""}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

interface SlotCapacityTooltipViewUtilInterface {
  classes: any;
  deliveryFeeSlotCapacityConfigDTOList: SlotCapacityViewUtilisationConfigurationInterface[];
}
export const SlotCapacityTooltipViewUtil = (props: SlotCapacityTooltipViewUtilInterface) => {
  const { classes, deliveryFeeSlotCapacityConfigDTOList } = props;

  return (
    <Card>
      <CardContent className={classes.thresholdRangeTooltipCardContent}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${DELIVERY_FEE_TEXT_CONSTANT.RANGE_START_GREATER_THAN_OR_EQUAL_TO}`}</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${DELIVERY_FEE_TEXT_CONSTANT.RANGE_END_LESS_THAN_}`}</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${DELIVERY_FEE_TEXT_CONSTANT.DELIVERY_FEES}`}</TableCell>{" "}
            </TableRow>
          </TableHead>
          <TableBody>
            {deliveryFeeSlotCapacityConfigDTOList.map((fee: SlotCapacityViewUtilisationConfigurationInterface, feeIndex: number) => (
              <TableRow key={`${feeIndex}-deliveryFeeRangeConfigDTOList-delivery-Fee-${fee?.capacityHigh ?? ""}`}>
                <TableCell className={classes.thresholdRangeTooltipTableCell}>{!isUndefined(fee?.capacityLow) ? fee.capacityLow : ""}</TableCell>
                <TableCell className={classes.thresholdRangeTooltipTableCell}>{fee?.capacityHigh ?? ""}</TableCell>
                <TableCell className={classes.thresholdRangeTooltipTableCell}>{!isUndefined(fee?.deliveryFee) ? fee.deliveryFee : ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export const getPromiseTimeInHourAndMinutes = (minutes: number) => `${Math.floor(minutes / 60)} hour ${minutes % 60} mins`;
export const getPromiseTimeInMinutes = (minutes: number) => `${minutes} mins`;

export const convertToMinutes = (maxTimeToSlot: any) => {
  let minutes: number = 0;
  if (!isUndefined(maxTimeToSlot)) {
    minutes = Math.floor(Number(maxTimeToSlot) / 60);
  }
  return getPromiseTimeInMinutes(minutes);
};

interface SlotProximityFeeTooltipViewUtilInterface {
  classes: any;
  slotProximityFeeConfigDTOList: slotProximityFeeConfigDTOListInterface[];
}

export const SlotProximityFeeTooltipViewUtil = (props: SlotProximityFeeTooltipViewUtilInterface) => {
  const { classes, slotProximityFeeConfigDTOList } = props;

  return (
    <Card>
      <CardContent className={classes.thresholdRangeTooltipCardContent}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${DELIVERY_FEE_TEXT_CONSTANT.PROXIMITY_TO_SLOT}`}</TableCell>
              <TableCell className={classes.thresholdRangeTooltipTableCell}>{`${DELIVERY_FEE_TEXT_CONSTANT.SLOT_PROXIMITY_FEE_TITLE}`}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {slotProximityFeeConfigDTOList.map((obj: slotProximityFeeConfigDTOListInterface, objIndex: number) => (
              <TableRow key={`${objIndex}-slotProximityFeeConfigDTOList-slot-Proximity-Fee-${obj?.deliveryFee ?? ""}`}>
                <TableCell className={classes.thresholdRangeTooltipTableCell}>{!isUndefined(obj?.maxTimeToSlot) ? convertToMinutes(obj.maxTimeToSlot) : ""}</TableCell>
                <TableCell className={classes.thresholdRangeTooltipTableCell}>{!isUndefined(obj?.deliveryFee) ? obj.deliveryFee : ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
